import { apiCall, createQueryString } from './helper';

export function fetchProject(projectId, params = {}) {
  return apiCall(`/projects/${projectId}?${createQueryString(params)}`);
}
